import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 1.875c5.592 0 10.125 4.533 10.125 10.125S17.592 22.125 12 22.125 1.875 17.592 1.875 12 6.408 1.875 12 1.875zm0 1.5a8.625 8.625 0 1 0 0 17.25 8.625 8.625 0 0 0 0-17.25zm0 12.25a1.063 1.063 0 1 1 0 2.125 1.063 1.063 0 0 1 0-2.125zm-.367-9.354a3.25 3.25 0 0 1 1.45 6.294.5.5 0 0 0-.333.472v.838a.75.75 0 1 1-1.5 0v-.838a2 2 0 0 1 1.333-1.887A1.75 1.75 0 1 0 10.25 9.5a.75.75 0 0 1-1.5 0 3.25 3.25 0 0 1 2.883-3.229z' />
  </svg>
);
